import { render, staticRenderFns } from "./NewTabTransitionPage.vue?vue&type=template&id=97d5c130&"
import script from "./NewTabTransitionPage.vue?vue&type=script&lang=ts&"
export * from "./NewTabTransitionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports